import { render, staticRenderFns } from "./CompVoiceChatRoom.vue?vue&type=template&id=66336835&scoped=true"
import script from "./CompVoiceChatRoom.vue?vue&type=script&lang=js"
export * from "./CompVoiceChatRoom.vue?vue&type=script&lang=js"
import style0 from "./CompVoiceChatRoom.vue?vue&type=style&index=0&id=66336835&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66336835",
  null
  
)

export default component.exports